import Axios from "@/plugins/Axios";

export class CodigosHabilidadesService {
  async listarPaginado(page = 1, search = "") {
    const response = await Axios().get("codigos-habilidades", {
      params: { page, search },
    });
    return response.data;
  }

  async buscarPorId(id) {
    const response = await Axios().get(`codigos-habilidades/${id}`);
    return response.data;
  }

  async salvar(dados) {
    const response = await Axios().post("codigos-habilidades", dados);
    return response.data;
  }

  async atualizar(id, dados) {
    const response = await Axios().put(`codigos-habilidades/${id}`, dados);
    return response.data;
  }

  async deletar(id) {
    const response = await Axios().delete(`codigos-habilidades/${id}`);
    return response.data;
  }

  async verificarUnicidade(serieId, disciplinaId, etapaId, excludeId = null) {
    const response = await Axios().get("codigos-habilidades/check-unique", {
      params: {
        serie_id: serieId,
        disciplina_id: disciplinaId,
        etapa_id: etapaId,
        exclude_id: excludeId,
      },
    });
    return response.data;
  }

  async checkCodigos(codigos, excludeId = null) {
    const response = await Axios().post("codigos-habilidades/check-codigos", {
      codigos,
      exclude_id: excludeId,
    });
    return response.data;
  }

  async disciplinasPorSerie(serieId) {
    const response = await Axios().get(`codigos-habilidades/series/${serieId}/disciplinas`);
    return response.data;
  }
}

export default new CodigosHabilidadesService();
